import { BetSlipFragment } from "../../graphql/core-types"
import { formatCurrency } from "../../helpers/currency"
import { getStakers, getStakersWinnings } from "../../helpers/stake-helpers"

// the line under a win saying what the stakers backing the bet made alongside the streamer
export const StakersWon = ({ betSlip, className = '' }: { betSlip: BetSlipFragment, className?: string }) => {
  const stakerCount = getStakers(betSlip).length
  const winnings = getStakersWinnings(betSlip)
  if (stakerCount === 0 || winnings <= 0) return null

  return (
    <span className={className}>
      +{formatCurrency(String(winnings))} won by {stakerCount} {stakerCount === 1 ? 'staker' : 'stakers'}
    </span>
  )
}
